/* Keep late-mounted customer widgets labelled without changing app behaviour. */
(() => {
  const labels = document.currentScript.dataset;
  const selector = '[class*="omnisend-form-"][class*="-rectangle-teaser-btn"]';
  // OCU pre-purchase offers lack the post-purchase language selector.
  // Translate only this known offer's displayed text; keep option values,
  // prices, app nodes, event listeners and checkout behavior intact.
  const ocuLithuanian = {
    'Something warm for the walks?': 'Kažko šilto pasivaikščiojimams?',
    'Add the Bear Jumpsuit to this order — 10% off, only here.': 'Pridėkite „Bear“ kombinezoną prie užsakymo – tik čia su 10 % nuolaida.',
    'Add the Bear Jumpsuit to this order — 15% off, only here.': 'Pridėkite „Bear“ kombinezoną prie užsakymo – tik čia su 15 % nuolaida.',
    'PerfectBaby™ Bear Jumpsuit': 'PerfectBaby™ Kūdikio kombinezonas „Bear“',
    'Ultra-soft plush with a warm inner lining, bear-ear hood, snap buttons for quick changes and secure cuffs. 0–18 months, four colours — pick colour and size below.': 'Minkštas pliušas, šiltas pamušalas, gobtuvas su meškiuko ausytėmis, patogios spaudės ir priglundantys rankogaliai. 0–18 mėn., keturios spalvos – pasirinkite spalvą ir dydį.',
    'Savings': 'Sutaupote', 'Color': 'Spalva', 'Size': 'Dydis',
    'Brown': 'Ruda', 'White': 'Balta', 'Grey': 'Pilka', 'Pink': 'Rožinė',
    '0-3 Months 59CM': '0–3 mėn. · 59 cm', '3-6 Months 66CM': '3–6 mėn. · 66 cm',
    '6-9 Months 73CM': '6–9 mėn. · 73 cm', '9-12 Months 80CM': '9–12 mėn. · 80 cm',
    '12-18 Months 90CM': '12–18 mėn. · 90 cm',
    'Add to order': 'Pridėti prie užsakymo',
    'No thanks, go to checkout': 'Ne, ačiū. Tęsti atsiskaitymą',
    'Close': 'Uždaryti', 'Previous image': 'Ankstesnė nuotrauka',
    'Next Image': 'Kita nuotrauka', 'Decrease quantity': 'Sumažinti kiekį',
    'Increase quantity': 'Padidinti kiekį'
  };
  const isLithuanian = /^lt(?:-|$)/i.test(document.documentElement.lang || '');
  function labelOcuOffer(dialog) {
      const title = dialog.getAttribute('aria-label');
      if (title !== 'Something warm for the walks?' && title !== ocuLithuanian['Something warm for the walks?']) return;
      const walker = document.createTreeWalker(dialog, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script,style,[contenteditable="true"]')) continue;
        // Options without explicit values derive their submitted value from text.
        if (parent.tagName === 'OPTION' && !parent.hasAttribute('value')) continue;
        const source = node.nodeValue.trim();
        if (Object.prototype.hasOwnProperty.call(ocuLithuanian, source)) {
          node.nodeValue = node.nodeValue.replace(source, ocuLithuanian[source]);
        }
      }
      [dialog, ...dialog.querySelectorAll('[aria-label]')].forEach(element => {
        const source = element.getAttribute('aria-label');
        if (Object.prototype.hasOwnProperty.call(ocuLithuanian, source)) element.setAttribute('aria-label', ocuLithuanian[source]);
      });
  }
  function labelWidget(widget) {
    if (isLithuanian && widget.matches('.ocu-pre[role="dialog"]')) labelOcuOffer(widget);
    const merchantFrame = widget.id === 'merchantwidgetiframe' ? widget : null;
    if (merchantFrame && !merchantFrame.getAttribute('title') &&
        /^https:\/\/www\.google\.com\/shopping\/merchantverse\//.test(merchantFrame.src)) {
      merchantFrame.setAttribute('title', 'Google Store Quality');
    }
    if (widget.matches(selector) && /claim your gift/i.test(widget.textContent || '')) {
      widget.textContent = labels.pbOfferText;
      widget.setAttribute('aria-label', labels.pbOfferLabel);
    }
  }
  // Discovery observes element insertions only. Text changes are watched only
  // inside registered widgets, so currency and product updates stay out of scope.
  const widgetSelector = selector + ',#merchantwidgetiframe' +
    (isLithuanian ? ',.ocu-pre[role="dialog"]' : '');
  const registered = new WeakSet();
  const pending = new Set();
  const addedRoots = new Set();
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(flush);
  }
  function register(widget) {
    if (registered.has(widget)) return;
    registered.add(widget);
    pending.add(widget);
    new MutationObserver(() => {
      if (!widget.isConnected) return;
      pending.add(widget);
      schedule();
    }).observe(widget, {childList: true, subtree: true, characterData: true});
  }
  function discover(root) {
    if (!root.isConnected) return;
    if (root.matches(widgetSelector)) register(root);
    if (root.firstElementChild) root.querySelectorAll(widgetSelector).forEach(register);
  }
  function flush() {
    queued = false;
    const roots = Array.from(addedRoots);
    roots.forEach(root => {
      let parent = root.parentElement;
      while (parent && !addedRoots.has(parent)) parent = parent.parentElement;
      if (!parent) discover(root);
    });
    addedRoots.clear();
    const widgets = Array.from(pending);
    pending.clear();
    widgets.forEach(widget => { if (widget.isConnected) labelWidget(widget); });
  }
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) addedRoots.add(node);
    }));
    if (addedRoots.size) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  document.querySelectorAll(widgetSelector).forEach(register);
  flush();
})();


/* 2026-10-14: keep the mobile home hero clear of the offer teaser. */
(function () {
  var hero = document.querySelector('main .pb-hero-slider-wrapper');
  if (!hero || !('IntersectionObserver' in window)) return;
  var style = document.createElement('style');
  style.textContent = '@media(max-width:989px){body.pb-home-hero-visible [class*="omnisend-form-"][class*="-rectangle-teaser"]{visibility:hidden!important;pointer-events:none!important;}}';
  document.head.appendChild(style);
  document.body.classList.add('pb-home-hero-visible');
  new IntersectionObserver(function (entries) {
    document.body.classList.toggle('pb-home-hero-visible', entries[0].isIntersecting);
  }, {threshold: 0}).observe(hero);
})();
